import store from '@/store/index'
import { UserGettersTypes, UserMutationTypes } from '@/store/modules/user'
import { TempMutationTypes } from '@/store/modules/temp'

// 檢查 token
// 1.檢查有無 2.檢查效期
export const checkAuth = (): boolean => {
  const tokenObj = store.getters[UserGettersTypes.GET_TOKEN]

  // 檢查 token base64
  if (!tokenObj.access_token) {
    return false
  }

  // 檢查 token 是否過期
  const expTime = tokenObj.expires_in || 0
  const nowTime = Math.floor(new Date().getTime() / 1000)
  const remainingTime = expTime - nowTime // 剩餘時間
  if (remainingTime <= 0) {
    // token 已過期
    return false
  }

  return true
}

export const logoutflow = () => {
  // clear token & profile & permission
  store.commit(UserMutationTypes.SET_TOKEN, {})
  store.commit(UserMutationTypes.SET_PROFILE, {})
  store.commit(UserMutationTypes.SET_PERMISSION, {})

  store.commit(TempMutationTypes.CLEAR_ALL) // 主動登出 > 刪除暫存的產品編輯資料
}
